import createTitleFabric from "../../../general/CoreHeader/components/Title/titleFabric";
import { createDisplayNameForHeaderClose } from "../../utils/createDisplayName";
import { createTestIdForHeaderClose } from "../../utils/createTestId";

const displayName = createDisplayNameForHeaderClose("Title");
const testId = createTestIdForHeaderClose("title");

const HeaderCloseTitle = createTitleFabric(displayName, testId);

export default HeaderCloseTitle;
